import { defaultTo } from 'lodash';
import { IModel, Model } from './Model';
import { SalesItemListingModel } from './SalesItemListingModel';

export interface IRabiesInformationContentModel extends IModel {
  rabiesInformationContentId: number;
  rabiesInformationId: number;
  salesItemId: number;
  salesItem: SalesItemListingModel;
}

export class RabiesInformationContentModel
  extends Model
  implements IRabiesInformationContentModel
{
  rabiesInformationContentId: number;
  rabiesInformationId: number;
  salesItemId: number;
  salesItem: SalesItemListingModel;

  constructor(params?: Partial<IRabiesInformationContentModel>) {
    super(params);
    this.rabiesInformationContentId = defaultTo(
      params?.rabiesInformationContentId,
      0,
    );
    this.rabiesInformationId = defaultTo(params?.rabiesInformationId, 0);
    this.salesItemId = defaultTo(params?.salesItemId, 0);
    this.salesItem = defaultTo(params?.salesItem, new SalesItemListingModel());
  }
}
